{
  "select": {
    "addTagText": "Add tag",
    "loadingText": "Loading",
    "notFoundText": "No data found",
    "clearAllText": "Clear all",
    "typeToSearchText": "Type to search",
    "placeholder": "Select"
  },
  "filter": {
    "buttons": {
      "showFilters": "Show filters",
      "hideFilters": "Hide filters",
      "clearFilters": "Clear filters",
      "defaultFilters": "Default filters",
      "showResults": "Show results"
    },
    "to": "to",
    "selected": "Selected {{count}}..."
  },
  "table": {
    "noResults": "No results",
    "pagination": {
      "summary": "Displaying {0}-{1} of {2}"
    }
  },
  "sort": {
    "title": "Sorting",
    "desc": "descending",
    "asc": "ascending"
  },
  "boolean": {
    "true": "Yes",
    "false": "No"
  },
  "downloadList": {
    "name": "Export data",
    "items": {
      "CSV": "csv",
      "XLSX": "xlsx"
    }
  },
  "messages": {
    "fileSizeError": "File upload failed – the maximum file size has been exceeded."
  }
}
